import apis from './apis';
import createApiRequest from '../util/createApiRequest';

const { request } = createApiRequest(apis);

export default request;
